import { useConst } from '@execonline-inc/react-hooks.private';
import { just } from 'maybeasy';
import { observer } from 'mobx-react';
import React from 'react';
import FilterStore from '../FilterTemplate/Store';
import SortStore from '../SortTemplate/Store';
import { trendingFirst } from '../SortTemplate/Types';
import { ExperiencesResource, FilterOptionData } from '../Types';
import { FilterStores } from './FilterStores';

interface Props {
  experiences: ExperiencesResource;
  children: React.ReactNode;
}

const FilterContext: React.FC<Props> = ({ experiences, children }) => {
  const createFilterStore = (options: Array<FilterOptionData>) =>
    useConst(() => new FilterStore(options));
  const productTypeFilterStore = createFilterStore(experiences.payload.productTypeFilterOptions);
  const durationFilterStore = createFilterStore(experiences.payload.durationFilterOptions);
  const competencyFilterStore = createFilterStore(experiences.payload.competencyFilterOptions);
  const schoolPartnerFilterStore = createFilterStore(
    experiences.payload.schoolPartnerFilterOptions,
  );
  const languageFilterStore = createFilterStore(
    experiences.payload.availableLanguagesFilterOptions,
  );
  const sortStore = useConst(() => new SortStore(trendingFirst));

  const filterContextValue = {
    productTypeFilterStore,
    durationFilterStore,
    competencyFilterStore,
    schoolPartnerFilterStore,
    languageFilterStore,
    sortStore,
  };

  return <FilterStores.Provider value={just(filterContextValue)}>{children}</FilterStores.Provider>;
};

export default observer(FilterContext);
